import { createElement } from 'react';
import CreditCardBrandMapping from '@tock/shared/constants/CreditCardBrandMapping';

interface CreditCardIconProps {
  brand?: string;
}

const CreditCardIcon: React.FunctionComponent<CreditCardIconProps> = ({ brand }) => {
  const { component } = CreditCardBrandMapping[brand || 'Unknown'];

  const iconComponent = createElement(component, {
    style: { fontSize: `3rem` },
  });

  return <div className="CreditCards-iconContainer">{iconComponent}</div>;
};

export default CreditCardIcon;
